document.addEventListener('DOMContentLoaded', () => {
  // 1. Find product data script to scope everything
  const productDataScript = document.querySelector('[data-product-json]');
  if (!productDataScript) {
    console.log('[Rental Variant] ℹ️ No product JSON found - skipping.');
    return;
  }

  // 2. Scope to the main product section
  // This ensures we target buttons/forms for THIS product, including sticky bars inside it.
  const productContainer = productDataScript.closest('section') || document.body;
  
  // 3. Find ALL add-to-cart buttons (Main + Sticky/Mini)
  // Both main and mini card buttons use .product-form__submit class
  const addToCartButtons = productContainer.querySelectorAll('.product-form__submit');
  
  // 4. Find ALL product forms (Main + Sticky/Mini)
  const productForms = productContainer.querySelectorAll('product-form form[data-type="add-to-cart-form"]');
  
  // 5. Find the main variant input
  const variantInput = productContainer.querySelector('input[name="id"]');
  
  // CONSTANTS
  // Perfect Mama+ (mama-tens) — update if variants recreated in Shopify admin
  const VARIANT_IDS = {
    BUY_749: 52890666303855,
    RENT_349: 52890666271087,
    RENT_149: 52890666238319
  };

  const RENTAL_BUTTON_TEXT = 'להשארת פרטים לחזרת נציג';

  if (addToCartButtons.length === 0 || !variantInput) {
    console.log('[Rental Variant] ⚠️ Required elements not found');
    return;
  }

  let isRentalVariant = false; // Global state

  // Store state for each button
  const buttonStates = new Map();

  addToCartButtons.forEach(button => {
    const label = button.querySelector('.button__label');
    if (label) {
      const initialText = label.getAttribute('data-label') || label.textContent.trim();
      buttonStates.set(button, {
        element: button,
        label: label,
        originalText: initialText,
        expectedText: initialText,
        observer: null
      });
    }
  });

  // Initialize Observers
  buttonStates.forEach((state) => {
    const { label } = state;
    state.observer = new MutationObserver((mutations) => {
      const currentText = label.textContent.trim();
      if (currentText !== state.expectedText && currentText !== '') {
         const hasTextChange = mutations.some(m => m.type === 'characterData' || m.type === 'childList');
         if (hasTextChange) {
            state.observer.disconnect();
            label.textContent = state.expectedText;
            state.observer.observe(label, { childList: true, characterData: true, subtree: true });
         }
      }
    });
    state.observer.observe(label, { childList: true, characterData: true, subtree: true });
  });

  // --- Core Functions ---

  function isRentalVariantTitle(title) {
    return title && title.includes('השכרה');
  }

  function openRentalModal(opener) {
    const rentalModal = document.querySelector('rent-product-modal');
    if (rentalModal) {
      const currentVariantId = variantInput.value;
      let product;
      try {
        product = JSON.parse(productDataScript.textContent);
      } catch(e) { return; }

      const selectedVariant = product.variants.find(v => v.id == currentVariantId);
      
      const productField = rentalModal.querySelector('[data-rental-product-field]');
      const variantField = rentalModal.querySelector('[data-rental-variant-field]');
      const priceField = rentalModal.querySelector('[data-rental-price-field]');
      
      if (productField) productField.value = `${product.title} (${product.handle})`;
      
      if (variantField) {
         if (currentVariantId == VARIANT_IDS.RENT_149) {
            // Explicitly set for 149 case
            const var149 = product.variants.find(v => v.id == VARIANT_IDS.RENT_149);
            variantField.value = var149 ? var149.title : selectedVariant.title;
         } else if (currentVariantId == VARIANT_IDS.RENT_349) {
            // Explicitly set for 349 case
            const var349 = product.variants.find(v => v.id == VARIANT_IDS.RENT_349);
            variantField.value = var349 ? var349.title : selectedVariant.title;
         } else {
            // Default fallback
            variantField.value = selectedVariant.title;
         }
      }

      // Update Visible "Purchase Type" Text in Modal Header
      const visibleVariantValue = rentalModal.querySelector('.card-extended__variant-value');
      if (visibleVariantValue) {
         if (currentVariantId == VARIANT_IDS.RENT_149) {
            const var149 = product.variants.find(v => v.id == VARIANT_IDS.RENT_149);
            visibleVariantValue.textContent = var149 ? var149.title : selectedVariant.title;
         } else if (currentVariantId == VARIANT_IDS.RENT_349) {
            const var349 = product.variants.find(v => v.id == VARIANT_IDS.RENT_349);
            visibleVariantValue.textContent = var349 ? var349.title : selectedVariant.title;
         } else {
            visibleVariantValue.textContent = selectedVariant.title;
         }
      }

      if (priceField && selectedVariant) priceField.value = (selectedVariant.price / 100).toFixed(2) + ' ₪';
      
      rentalModal.show(opener);
    }
  }

  function updateButtonForVariant(specificVariantId = null) {
    const variantId = Number(specificVariantId || variantInput.value);
    
    let product;
    try {
      product = JSON.parse(productDataScript.textContent);
    } catch (e) { return; }

    const selectedVariant = product.variants.find(v => v.id == variantId);
    if (!selectedVariant) return;

    // Only Clalit/referral rental (149 ₪) opens the contact modal.
    // Regular rental (349 ₪) and purchase use normal add-to-cart.
    const isRental = variantId === VARIANT_IDS.RENT_149;
    isRentalVariant = isRental;

    // 1. Update Prices
    updatePriceDisplay(selectedVariant);

    // 2. Update Buttons
    buttonStates.forEach((state) => {
      const { element, label, originalText } = state;
      
      if (isRental) {
        state.expectedText = RENTAL_BUTTON_TEXT;
        label.textContent = RENTAL_BUTTON_TEXT;
        element.classList.add('product-form__submit--rental');
        element.setAttribute('data-rental-button', 'true');
      } else {
        state.expectedText = originalText;
        label.textContent = originalText;
        element.classList.remove('product-form__submit--rental');
        element.removeAttribute('data-rental-button');
      }
    });

    // 3. Toggle Quantity Selector
    const quantityWrapper = document.querySelector('[data-quantity-wrapper]');
    if (quantityWrapper) {
      quantityWrapper.style.display = isRental ? 'none' : 'block';
    }
  }

  function updatePriceDisplay(selectedVariant) {
    const priceWrappers = document.querySelectorAll('.price-wrapper-inner, .mini-card__content-text .price');
    if (priceWrappers.length === 0) return;

    const formattedPrice = (selectedVariant.price / 100).toFixed(2).replace(/\.00$/, '') + ' ₪';
    const onSale = selectedVariant.compare_at_price > selectedVariant.price;

    priceWrappers.forEach((priceWrapper) => {
      const priceContainer = priceWrapper.classList.contains('price') ? priceWrapper : (priceWrapper.closest('.price') || priceWrapper.querySelector('.price'));
      const regularPrices = priceWrapper.querySelectorAll('.price-item--regular');
      const salePrices = priceWrapper.querySelectorAll('.price-item--sale');
      
      regularPrices.forEach(el => {
        if (onSale && selectedVariant.compare_at_price) {
           const formattedCompare = (selectedVariant.compare_at_price / 100).toFixed(2).replace(/\.00$/, '') + ' ₪';
           el.textContent = formattedCompare;
           el.style.textDecoration = 'line-through';
           el.style.color = '#777';
           el.style.fontSize = '1.8rem';
        } else {
           el.textContent = formattedPrice;
           el.style.textDecoration = 'none';
           el.style.color = '#1e4838';
           el.style.fontWeight = '700';
           el.style.fontSize = '2.8rem';
        }
      });

      salePrices.forEach(el => {
        el.textContent = formattedPrice;
        el.style.display = onSale ? 'inline-block' : 'none';
        if (onSale) {
            el.style.textDecoration = 'none';
            el.style.color = '#1e4838';
            el.style.fontWeight = '700';
            el.style.fontSize = '2.8rem';
        }
      });

      if (priceContainer) {
        if (onSale) {
          priceContainer.classList.add('price--on-sale');
          priceContainer.classList.remove('price--no-compare');
        } else {
          priceContainer.classList.remove('price--on-sale');
        }
      }
    });
  }

  // --- Event Interception ---

  addToCartButtons.forEach(button => {
    // Click Handler (Modal)
    button.addEventListener('click', (e) => {
      if (isRentalVariant) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        openRentalModal(button);
        return false;
      }
    }, true);
  });

  productForms.forEach(form => {
    form.addEventListener('submit', (e) => {
      if (isRentalVariant) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        openRentalModal(null);
        return false;
      }
    });
  });

  // --- Global Access & Listeners ---

  window.handleRentalVariantChange = function(variantId) {
    // Sync ALL id inputs (main + sticky forms) so ATC uses selected variant
    productContainer.querySelectorAll('input[name="id"]').forEach((input) => {
      input.value = variantId;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    updateButtonForVariant(variantId);
  };

  document.addEventListener('variant:change', () => setTimeout(updateButtonForVariant, 100));

  if (variantInput) {
      variantInput.addEventListener('change', () => updateButtonForVariant());
  }

  const variantSelectors = document.querySelectorAll('variant-selects, variant-radios');
  variantSelectors.forEach((selector) => {
    const inputs = selector.querySelectorAll('select, input[type="radio"]');
    inputs.forEach((el) => {
      el.addEventListener('change', () => setTimeout(updateButtonForVariant, 50));
    });
  });

  if (variantInput) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((m) => {
          if (m.type === 'attributes' && m.attributeName === 'value') {
            updateButtonForVariant();
          }
        });
      });
      observer.observe(variantInput, { attributes: true });
  }

  // Initial Run
  updateButtonForVariant();

});